import request from '../api/request'
import axios from "axios";
import businessHelper from "../helpers/BusinessHelper";

function teachers() {
    return request({
        url: `/teachers.json`,
        method: 'GET'
    });
}

function teacher(id) {
    return request({
        url: `/teachers/${id}.json`,
        method: 'GET'
    });
}

function addTeacherPayment(teacherId, data) {
    return request({
        url: `/teachers/${teacherId}/add_class_payment.json`,
        method: 'POST',
        data: data
    });
}

function deleteTeacherPhoto(teacher) {
    return request({
        url: `/teachers/${teacher.id}/delete_photo.json`,
        method: 'POST',
        data: {user_id: teacher.created_by}
    });
}

function teacherSalary(id, selectedDate) {
    return request({
        url: `/teachers/${id}/teacher_salary.json?date=${selectedDate}`,
        method: 'GET'
    });
}

function teacherClasses(teacherId, selectedDate) {
    return request({
        url: `/yclasses/light.json?teacher_id=${teacherId}&date=${selectedDate}`,
        method: 'GET'
    });
}

function rooms() {
    return request({
        url: `rooms.json`,
        method: 'GET'
    });
}

function teachersAndRooms() {
    return axios.all([teachers(), rooms()])
}

function teachersRoomsClassTypes() {
    return axios.all([teachers(), rooms(), classTypes()])
}

function postTeacher(teacher) {
    return request({
        url: `teachers.json`,
        method: 'POST',
        data: teacher
    });
}

function updateTeacher(teacher) {
    return request({
        url: `teachers/${teacher.id}.json`,
        method: 'PUT',
        data: teacher
    });
}

function deleteTeacher(teacher) {
    return request({
        url: `teachers/${teacher.id}.json`,
        method: 'DELETE'
    });
}

function postRoom(room) {
    return request({
        url: `rooms.json`,
        method: 'POST',
        data: room
    });
}

function updateRoom(room) {
    return request({
        url: `rooms/${room.id}.json`,
        method: 'PUT',
        data: room
    });
}

function deleteRoom(room) {
    return request({
        url: `rooms/${room.id}.json`,
        method: 'DELETE'
    });
}

function removeClientFromClassType(classTypeId, clientId) {
    return request({
        url: `class_types/${classTypeId}.json?remove=t&student_id=${clientId}`,
        method: 'PUT'
    });
}

function addClientToClassType(classTypeId, clientId) {
    return request({
        url: `class_types/${classTypeId}.json?student_id=${clientId}`,
        method: 'PUT'
    });
}

function postClassType(classType) {
    return request({
        url: `class_types.json`,
        method: 'POST',
        data: classType
    });
}

function postTicketType(tt) {
    return request({
        url: `ticket_type.json`,
        method: 'POST',
        data: tt
    });
}

function toggleTicketTypePublic(tt) {
    return request({
        url: `ticket_type/${tt.id}/switch_sellable.json`,
        method: 'PUT',
        data: {ticket_type_id: tt.id}
    });
}

function postMembershipTicketType(tt) {
    return request({
        url: `memberships/create_price.json`,
        method: 'POST',
        data: tt
    });
}

function updateClassType(classType) {
    return request({
        url: `class_types/${classType.id}.json`,
        method: 'PUT',
        data: classType
    });
}

function copyClassType(classTypeId) {
    return request({
        url: `class_types/${classTypeId}/copy.json`,
        method: 'POST',
    });
}

function copyTicketType(ticketTypeId) {
    return request({
        url: `ticket_type/${ticketTypeId}/copy.json`,
        method: 'POST',
    });
}

function deleteClassType(classType) {
    return request({
        url: `class_types/${classType.id}.json`,
        method: 'DELETE',
    });
}

function updateTicketType(tt) {
    return request({
        url: `ticket_type/${tt.id}.json`,
        method: 'PUT',
        data: tt
    });
}

function createPromoCode(promoCode) {
    return request({
        url: `ticket_type/${promoCode.ticket_type_id}/create_promo_code.json`,
        method: 'POST',
        data: promoCode
    });
}

function getPromoCodes(ticketTypeId) {
    return request({
        url: `ticket_type/${ticketTypeId}/promo_codes.json`,
        method: 'GET',
    });
}

function deletePromoCode(ticketTypeId, promoCodeId) {
    return request({
        url: `ticket_type/${ticketTypeId}/delete_promo_code.json`,
        method: 'POST',
        data: {promo_code_id: promoCodeId}
    });
}

function deleteTicketType(tt) {
    return request({
        url: `ticket_type/${tt.id}.json`,
        method: 'DELETE',
    });
}

function classType(id) {
    return request({
        url: `class_types/${id}.json`,
        method: 'GET',
    });
}

function classTypes() {
    return request({
        url: `class_types.json`,
        method: 'GET',
    });
}

function loadWorkshops() {
    return request({
        url: `class_types.json?only_workshops=t`,
        method: 'GET',
    });
}

function deleteRule(classTypeId, ruleId) {
    return request({
        url: `class_types/${classTypeId}/rules/${ruleId}.json`,
        method: 'DELETE',
    });
}

function postRule(classTypeId, data) {
    return request({
        url: `class_types/${classTypeId}/rules.json`,
        method: 'POST',
        data: data
    });
}

function updateRule(classTypeId, rule) {
    return request({
        url: `class_types/${classTypeId}/rules/${rule.id}.json`,
        method: 'PUT',
        data: rule
    });
}

function postEvent(event) {
    return request({
        url: `users/${businessHelper.business().id}/open_events.json`,
        method: 'POST',
        data: event
    });
}

function updateEvent(event) {
    return request({
        url: `users/${businessHelper.business().id}/open_events/${event.id}.json`,
        method: 'PUT',
        data: event
    });
}

function updateProduct(productParams) {
    return request({
        url: `users/${businessHelper.business().id}/products/${productParams.id}.json`,
        method: 'PUT',
        data: productParams
    });
}

function saveProduct(productParams) {
    return request({
        url: `products/send_payment_link.json`,
        method: 'POST',
        data: productParams
    });
}

function deleteProduct(id) {
    return request({
        url: `products/${id}/delete.json`,
        method: 'POST',
    });
}

function deleteEvent(event) {
    return request({
        url: `users/${businessHelper.business().id}/open_events/${event.id}.json`,
        method: 'DELETE',
    });
}

function addGroupToClassType(ctId, groupId) {
    return request({
        url: `class_types/${ctId}/add_group.json?group_id=${groupId}`,
        method: 'PUT',
    });
}

function removeGroupFromClassType(ctId, groupId) {
    return request({
        url: `class_types/${ctId}/remove_group.json?group_id=${groupId}`,
        method: 'PUT',
    });
}

//LOCALES

function createLocale(params) {
    return request({
        url: `locales.json`,
        method: 'POST',
        data: params
    });
}

function updateLocale(params) {
    return request({
        url: `locales/${params.id}.json`,
        method: 'PUT',
        data: params
    });
}

function deleteLocale(params) {
    return request({
        url: `locales/${params.id}.json`,
        method: 'DELETE',
    });
}

function loadLocales() {
    return request({
        url: `locales.json`,
        method: 'GET',
    });
}

function products() {
    return request({
        url: `products.json`,
        method: 'GET',
    });
}

function paymentLinkRequest() {
    return request({
        url: `products/plr.json`,
        method: 'POST',
    });
}

function donationInrst() {
    return request({
        url: `users/donation_inrst.json`,
        method: 'POST',
    });
}

function referralInrst() {
    return request({
        url: `users/ref_inrst.json`,
        method: 'POST',
    });
}

function setTeacherPriority(data) {
    return request({
        url: `teachers/set_priority.json`,
        method: 'POST',
        data: {teacher_priority: data}
    });
}

const ResourceApiService = {
        teachers,
        rooms,
        teachersAndRooms,
        postTeacher,
        updateTeacher,
        deleteTeacher,
        postRoom,
        updateRoom,
        deleteRoom,
        addClientToClassType,
        removeClientFromClassType,
        postClassType,
        classType,
        updateClassType,
        classTypes,
        loadWorkshops,
        deleteRule,
        postRule,
        updateRule,
        postTicketType,
        updateTicketType,
        deleteClassType,
        deleteTicketType,
        teacher,
        teacherSalary,
        teacherClasses,
        addTeacherPayment,
        teachersRoomsClassTypes,
        postEvent,
        updateEvent,
        deleteEvent,
        addGroupToClassType,
        removeGroupFromClassType,
        postMembershipTicketType,
        copyClassType,
        copyTicketType,
        createLocale,
        updateLocale,
        deleteLocale,
        loadLocales,
        createPromoCode,
        getPromoCodes,
        deletePromoCode,
        toggleTicketTypePublic,
        donationInrst,
        referralInrst,
        saveProduct,
        deleteProduct,
        products,
        paymentLinkRequest,
        setTeacherPriority,
        deleteTeacherPhoto
    }
;

export default ResourceApiService;